<template>
    <div class="common_bottom" id="loginbottom" :class="position=='fixed'?'common_bottomfixed':''">
        <div class="content_wrap">
            <div class="content_box">
                <div class="icon-img">
                    <img class="pic_full" src="../../assets/image/common/new/handback.png" />
                </div>
                <div class="icon-img1"></div>
                <div class="content_text">每成功推荐一个朋友学习，满足条件可获得200元充值</div>
                <div class="qrbox">
                    <div class="qrcode">
                        <canvas id="wechat_qrcode"></canvas>
                    </div>
                    <div class="wechatbox">
                        <span class="wechat_icon">
                            <img src="../../assets/image/user_center/icon (2).png" alt='微信' class="pic_full" />
                        </span>
                        <span class="wechat_text">扫码分享到微信</span>
                    </div>
                </div>
                <div class="check_benefit" @click="$router.push('/user-benefit')">查看奖励</div>
            </div>
        </div>
    </div>
</template>
<script>
import {common} from '../../../common';
import QRCode from "qrcode";
export default {
    props: ['detectscroll'],
    data: function(){
        return {
            position: 'fixed'
        }
    },
    mounted: function() {
        this.get_share_code();
        let self = this;
        function detectbanner() {
            let top = document.querySelector(".common_foot").offsetTop;
            let height = document.documentElement.clientHeight;
            let scrollTop = 0;
            if (document.documentElement && document.documentElement.scrollTop) {
                scrollTop = document.documentElement.scrollTop;
            } else if (document.body) {
                scrollTop = document.body.scrollTop;
            }
            if (scrollTop + height >= top - 160) {
                if (self.position) {
                self.position = "";
                }
            } else {
                if (!self.position) {
                self.position = "fixed";
                }
            }
        }

        if (this.detectscroll) {
            detectbanner();
            window.onscroll = function () {
                detectbanner();
            };
        } else {
            this.position = "";
        }
    },
    methods: {
        get_share_code() {
            //生成分享二维码
            let self = this;
            common.requestFun(self, "get", "/student/recommend_code", {}, res => {
                if (res.data.code == 200) {
                    var msg = document.getElementById("wechat_qrcode");
                    QRCode.toCanvas(msg,`https://gemsbaby.com/share/index.html?origin_code=${res.data.data}`,{width: 130},function(error) {
                        error&&console.log(error);
                    });
                }
            });
        },
    }
}
</script>
<style scoped src="./common_bottom.css"></style>